import { addDays, differenceInCalendarDays } from 'date-fns';

import { Class } from '@tgg/services';
import { getFormattedDate, reduceByProperty } from '@tgg/util';

export type GetClassesForDayParameters = {
    classes: Class[];
    startDate: Date;
    endDate: Date;
};

export const getAbsoluteDatesInterval = (startDate: Date, endDate: Date) => {
    return Math.abs(
        Number.isNaN(differenceInCalendarDays(startDate, endDate))
            ? 0
            : differenceInCalendarDays(startDate, endDate),
    );
};

export const useGetTabsContent = ({
    classes,
    startDate,
    endDate,
}: GetClassesForDayParameters) => {
    const now = new Date();

    const transformFunction = (startTime: Date | string) =>
        getFormattedDate(startTime.toString(), 'EEE d');
    const classesAggregatedByDate = reduceByProperty(
        classes,
        'startTime',
        transformFunction,
    );

    const interval = getAbsoluteDatesInterval(startDate, endDate);

    const tabsData =
        interval > 0
            ? // eslint-disable-next-line unicorn/no-new-array
              new Array(interval + 1).fill({}).map((_, index) => ({
                  name: transformFunction(addDays(now, index)),
                  data: classesAggregatedByDate[
                      transformFunction(addDays(now, index))
                  ]
                      ? classesAggregatedByDate[
                            transformFunction(addDays(now, index))
                        ]
                      : [],
              }))
            : [];

    return {
        tabsData,
    };
};

export const checkClassAvailability = (
    capacityBooked: number,
    bookedMax: number,
) => {
    return capacityBooked === bookedMax ? 'fully booked' : 'available';
};
